module.exports = __webpack_public_path__ + "static/media/Opt_out_message.91f3b7e1.svg";